import { render, staticRenderFns } from "./author-card.vue?vue&type=template&id=96896dd2&scoped=true"
import script from "./author-card.vue?vue&type=script&lang=ts"
export * from "./author-card.vue?vue&type=script&lang=ts"
import style0 from "./author-card.vue?vue&type=style&index=0&id=96896dd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96896dd2",
  null
  
)

export default component.exports